import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FinalExitList from "../FinalExitList";
import { setBreadCrumb } from "../../../../../store/userSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import FinalExitDetails from "../FinalExitDetails/FinalExitDetails";

export default function ExitFormalitiesQueueTab({ setIndex }) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const location = useLocation();
  const { employeeID } = useParams();
  const [id, setId] = useState(employeeID);
  const [triggerNew, setTriggerNEW] = useState(false);
  const isDetailsPage = location.pathname.includes("/final-exit/details/");
  const commonItems = [{ label: "final exit", link: "/dashboard/final-exit" }];
  const breadcrumbItems = isDetailsPage
    ? [...commonItems, { label: id, link: "" }]
    : commonItems;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const updateNew = () => {
    setTriggerNEW(true);
  };

  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.includes("/final-exit/details/")) {
      setAddOrEdit((p) => ({ ...p, open: true }));
      // Update id from URL parameter
      if (employeeID) {
        setId(employeeID);
      }
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location, employeeID]);

  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname]);

  const [propData, setPropsData] = useState("");

  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            <FinalExitList
              setId={setId}
              setPropsData={setPropsData}
            />
          </>
        )}
        {addOrEdit.open && (
          <FinalExitDetails
            employeeID={id}
            updateAPI={() => {}}
            setAddOrEdit={setAddOrEdit}
            addOrEdit={addOrEdit}
            repatration={propData}
            setIndex={setIndex}
            updateNew={updateNew}
            redirectPath="/dashboard/final-exit"
            isLocalExit={false}
          />
        )}
      </div>
    </>
  );
}
